
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offers",
      function () {
        return require("private-next-pages/offers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offers"])
      });
    }
  